import React, { forwardRef } from 'react'
import {
    InputGroup,
    InputLeftElement,
    Icon,
    Input,
    InputProps,
} from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'

interface SharedSearchInputProps extends InputProps {
    groupVariant?: 'ghost' | 'outline' | 'filled'
}

const SharedSearchInput = forwardRef<HTMLInputElement, SharedSearchInputProps>(
    (props, ref) => {
        const { groupVariant = 'ghost', ...rest } = props

        return (
            <InputGroup variant={groupVariant} size={rest.size}>
                <InputLeftElement>
                    <Icon as={FiSearch} color="gray.600" />
                </InputLeftElement>
                <Input ref={ref} {...rest} />
            </InputGroup>
        )
    }
)

SharedSearchInput.displayName = 'SharedSearchInput'

export default SharedSearchInput
